// extracted by mini-css-extract-plugin
export default {"noDataContainer":"noData_noDataContainer__Ub8Pi","title":"noData_title__U1P+7","icon":"noData_icon__20wtP","message":"noData_message__yF-zn"};